import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/pendiente/importer/pendienteImporterActions';

export default importerReducers(actions);
